import React, { useEffect, useState } from 'react';
import api from '../api';

const Alignment = () => {
    const [traits, setTraits] = useState([]);
    const [moods, setMoods] = useState([]);
    const [newTrait, setNewTrait] = useState('');
    const [newMood, setNewMood] = useState('');

    useEffect(() => {
        api.get('/alignment/traits').then(res => setTraits(res.data));
        api.get('/alignment/moods').then(res => setMoods(res.data));
    }, []);

    const addTrait = () => {
        api.post('/alignment/traits', { trait: newTrait })
            .then(res => setTraits([...traits, res.data]))
            .catch(() => alert('Error adding trait'));
        setNewTrait('');
    };

    const deleteTrait = (id) => {
        api.delete(`/alignment/traits/${id}`)
            .then(() => setTraits(traits.filter(t => t.id !== id)))
            .catch(() => alert('Error deleting trait'));
    };

    const addMood = () => {
        api.post('/alignment/moods', { mood: newMood })
            .then(res => setMoods([...moods, res.data]))
            .catch(() => alert('Error adding mood'));
        setNewMood('');
    };

    const deleteMood = (id) => {
        api.delete(`/alignment/moods/${id}`)
            .then(() => setMoods(moods.filter(m => m.id !== id)))
            .catch(() => alert('Error deleting mood'));
    };

    return (
        <div className="terminal min-h-screen flex flex-col items-center px-4 py-6 font-mono text-green-300">
            <div className="w-full max-w-6xl">
                <h2 className="text-center text-green-400 text-xl mb-2">
                    🧠 aiALIGNMENT — UMA Personality Modules
                </h2>

                <p className="text-green-500 text-sm mb-6 text-center max-w-3xl mx-auto opacity-70 leading-snug">
                    Traits define the AI’s core beliefs and values. Moods control how those traits are expressed. These
                    elements influence tone, attitude, and alignment ethics when generating UMA Injectors.
                </p>

                {/* Add Trait & Mood Card */}
                <div className="border border-green-500 rounded-xl bg-black shadow-lg mb-8 max-w-3xl mx-auto p-6">
                    <div className="flex flex-col md:flex-row gap-6">
                        {/* Add Trait */}
                        <div className="flex-1">
                            <h3 className="text-green-400 text-lg mb-2 text-center md:text-left">💚 Add Alignment Core (Trait)</h3>
                            <div className="flex gap-2 mb-2">
                                <input
                                    className="input-terminal w-full"
                                    value={newTrait}
                                    onChange={(e) => setNewTrait(e.target.value)}
                                    placeholder="e.g., Loyal, Hates injustice"
                                />
                                <button onClick={addTrait} className="btn-primary">Add</button>
                            </div>
                        </div>
                        {/* Add Mood */}
                        <div className="flex-1">
                            <h3 className="text-green-400 text-lg mb-2 text-center md:text-left">🧠 Add Expression Layer (Mood)</h3>
                            <div className="flex gap-2 mb-2">
                                <input
                                    className="input-terminal w-full"
                                    value={newMood}
                                    onChange={(e) => setNewMood(e.target.value)}
                                    placeholder="e.g., Sarcastic and flirty, Cold and clinical"
                                />
                                <button onClick={addMood} className="btn-primary">Add</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Traits & Moods List Card */}
                <div className="border border-green-500 rounded-xl bg-black shadow-lg max-w-4xl mx-auto p-6">
                    <div className="flex flex-col md:flex-row gap-8">
                        {/* Traits List */}
                        <div className="flex-1">
                            <h3 className="text-green-400 text-lg mb-3 text-center md:text-left">💚 Alignment Core (Traits)</h3>
                            <ul className="space-y-2 max-h-72 overflow-y-auto pr-2">
                                {traits.map(trait => (
                                    <li key={trait.id} className="flex justify-between items-center border border-green-700 px-3 py-1 rounded">
                                        <span>{trait.trait}</span>
                                        <button
                                            onClick={() => deleteTrait(trait.id)}
                                            className="bg-black text-green-400 border border-green-500 px-2 py-1 rounded hover:text-red-400"
                                        >
                                            Delete
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* Moods List */}
                        <div className="flex-1">
                            <h3 className="text-green-400 text-lg mb-3 text-center md:text-left">🧠 Expression Layer (Moods)</h3>
                            <ul className="space-y-2 max-h-72 overflow-y-auto pr-2">
                                {moods.map(mood => (
                                    <li key={mood.id} className="flex justify-between items-center border border-green-700 px-3 py-1 rounded">
                                        <span>{mood.mood}</span>
                                        <button
                                            onClick={() => deleteMood(mood.id)}
                                            className="bg-black text-green-400 border border-green-500 px-2 py-1 rounded hover:text-red-400"
                                        >
                                            Delete
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alignment;